module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter_01"
    }
  }, [_vm._v("Nothing Missing but the Samovar")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter_02"
    }
  }, [_vm._v("The Voice of God in Adelaide Terrace")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpreting the Past")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Servants Talk About People: Gentlefolk Discuss Things")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Help")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miss Carlton and the Pop Concert")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revenant as Typewriter")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Next Term, We'll Mash You")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At the Pitt-Rivers")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nice People")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A World of Her Own")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Presents of Fish and Game")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Clean Death")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Party")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corruption")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Venice, Now and Then")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grow Old Along With Me, the Best Is Yet To Be")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Darkness Out There")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pill-Box")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Customers")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yellow Trains")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The Ghost of a Flea’")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Art of Biography")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What the Eye Doesn't See")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Emasculation of Ted Roper")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Chapter_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Long Night at Abu Simbel")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bus-Stop")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/034_Chapter_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clara's Day")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The French Exchange")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/036_Chapter_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dream Merchant")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pack of Cards")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/038_Chapter_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crimean Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Dream of Fair Women")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/040_Chapter_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Dog")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c55e195","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 78
// module chunks = 0